module.exports = __webpack_public_path__ + "static/media/touch.216a8ca4.jpg";